import { useQuery, type UseQueryOptions } from 'react-query';

import { type IPlaybook as IOldPlaybook, PlaybookRunStatus } from 'src/api/playbooks-api';
import type { IPlaybookV2 } from 'src/services/api/playbooks/types';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';

type IGetPlaybooksResponse = {
    automations: IOldPlaybook[];
};

export const usePlaybooks = () => {
    return useQuery<IOldPlaybook[]>(
        queryKeys.playbooks,
        async () => {
            const path = 'api/landlord/automations?whole_team=true';
            const res = await apiClient(path)
                .json<IGetPlaybooksResponse>();

            return res.automations;
        }, {
            // refetch data every two seconds if one of the "current" runs has pending(running/queued) status
            refetchInterval(data: IOldPlaybook[] | undefined) {
                if (data?.some(playbook => {
                    return [PlaybookRunStatus.RUNNING, PlaybookRunStatus.QUEUED]
                        .includes(playbook.latest_run?.status as PlaybookRunStatus);
                })) {
                    return 2000;
                }
                return 0;
            }
        }
    );
};

export const useTeamPlaybooks = (options?: UseQueryOptions<IOldPlaybook[]>) => {
    return useQuery<IOldPlaybook[]>(
        queryKeys.teamPlaybooks,
        async () => {
            const res = await apiClient('api/landlord/automations?whole_team=true')
                .json<IGetPlaybooksResponse>();

            return res.automations;
        },
        options
    );
};

type IGetPlaybooksV2Response = {
    playbooks: IPlaybookV2[];
};

export const usePlaybooksV2 = () => {
    return useQuery<IPlaybookV2[]>(
        queryKeys.playbooksV2,
        async () => {
            const res = await apiClient('api/landlord/playbooks?whole_team=true').json<IGetPlaybooksV2Response>();
            return res.playbooks;
        }
    );
};
